import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useAgentMarketplaceLdFlags = createFlagsHook<typeof import('./flags.json')>()
